import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import css from './description.css';

const Description = ({ as: Component, children, className, ...otherProps }) => (
  <Component
    className={classnames([css['ds-card-description'], className])}
    {...otherProps}
  >
    {children}
  </Component>
);

Description.defaultProps = {
  as: 'p',
  children: null,
  className: '',
};
Description.propTypes = {
  as: PropTypes.oneOf(['p', 'span']),
  children: PropTypes.node,
  className: PropTypes.string,
};

export default Description;
